import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import Axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import store from './store';
import VueYouTubeEmbed from 'vue-youtube-embed';
import Vuelidate from 'vuelidate';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
//import drizzleVuePlugin from ' @drizzle/vue-plugin';
//import drizzleOptions from './drizzleOptions';

import {baseApiURL} from './configs'

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.config.performance = true;
Vue.prototype.$log = console.log.bind(console);
Vue.component('v-select', vSelect);
Vue.use(require('vue-moment'));
Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube-media' });
Vue.use(Vuelidate);

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = token;
}

Vue.prototype.$http.defaults.baseURL= baseApiURL+'/api';

Axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
